



import React from 'react'
import './EventSuccess.css'



const EventSuccess:React.FC = () => {
    



  return (
   <>
   
   <div className=' w-screen h-screen overflow-hidden bg-black p-3 custom-event-success-page-container'>
    <div className=' flex items-center justify-center mx-auto max-w-[800px] p-4 '>
       <div className=' sm:text-lg md:text-lg lg:text-3xl xl:text-3xl text-white font-mono '><h3>Thank You Our Support Team Reach Out To You </h3></div>

    </div>
   </div>
   
   
   
   
   </>
  )
}

export default EventSuccess
